import { Injectable } from '@angular/core';
import { EclesialNotificationService } from './eclesial.notification.service';
import { ExpiredPermissionUiStatic } from '@app/features/expired-permission-ui/expired-permission-ui.static';

@Injectable()
export class ErrorHandlerService {

    constructor(
        private _eclesialNotificationService: EclesialNotificationService,
    ) { }

    handle(error: any) {
        if (error.error.notifications) {
            let message = '';
            for (let notification of error.error.notifications) {
                message += notification;
            }

            for (let message in error.error.notifications) {
                setTimeout(() => {
                    this._eclesialNotificationService.notifyWarning(error.error.notifications[message]);
                }, 700);
            }
        } else if (error.error.errorDescription) {

            let message = `${error.error.errorDescription}`;

            this._eclesialNotificationService.notifyError(message);
        } else {
            this._eclesialNotificationService.notifyError(error.message);
        }
    }
}